import React, { FunctionComponent, useEffect } from "react";
import appPath from "utils/appPath";
import appConfig from "utils/appConfig";
import { Checkmark, EmailForm, PrimaryButton } from "bb.lego-ui";
import Header from "components/v4/header/Header";
import GoogleTracking from "services/GoogleTracking";
import Message from "utils/Message";
import styles from "./styles.module.scss";

export interface SignupProps {
    thinking: boolean | undefined;
    errors: Record<string, { type: string; message: string } | undefined>;
    email: string | undefined;
    country: string | undefined;
    closeable: boolean;
    onSignup: (email: string, optIn: boolean, captcha?: string) => Promise<void>;
    title?: string;
    buttonCopy?: string;
    successCopy?: string;
}

const Signup: FunctionComponent<SignupProps> = ({
    errors,
    country,
    email,
    closeable,
    thinking,
    onSignup,
    title = "Register to access this article",
    buttonCopy = "Create account to continue reading",
    successCopy = "You've unlocked exclusive content on Bloomberg.com"
}: SignupProps) => {
    useEffect(() => {
        GoogleTracking.setDataLayerFields({
            action: "Signup",
            cd9: "signup",
            cd13: "signup"
        });
    }, []);

    const onGotIt = (): void => {
        Message.userCloseWindow();
    };

    if (email) {
        let gotItButton = (
            <PrimaryButton
                onClick={ onGotIt }
                fullWidth={ true }
            >
                OK, got it.
            </PrimaryButton>
        );

        if (!appPath.isIframePath()) {
            gotItButton = (
                <PrimaryButton
                    href={ appConfig().bloombergSiteUrl }
                    target=""
                    fullWidth={ true }
                >
                    OK, got it.
                </PrimaryButton>
            );
        }

        return (
            <div>
                <div className={ styles.successCheck }>
                    <Checkmark color="green" size="large" />
                </div>
                <div className={ styles.successPageHeader }>
                    <Header title="" closeable={ closeable }>
                        <h2 className={ styles.successHeader }>Success!</h2>
                        <h2 className={ styles.successGap }>{ successCopy }</h2>
                    </Header>
                </div>
                <div className={ styles.successText }>
                    { /* eslint-disable-next-line max-len */ }
                    Discover more of Bloomberg.com by completing your account set up. Check your email to get started and stay tuned for exclusive offers.
                </div>
                <div selectid="got-it" className={ styles.successGotIt }>
                    { gotItButton }
                </div>
            </div>
        );
    }

    const error = errors.register ? errors.register.message : undefined;

    return (
        <div>
            <div className={ styles.header }>
                <Header title={ title } closeable={ closeable }>
                    <span className={ styles.headerGap } />
                </Header>
            </div>
            <div selectid="registration-v4-email-form" className={ styles.body }>
                <EmailForm
                    isUSUser={ country === "US" }
                    centeredLayout={ true }
                    buttonText={ buttonCopy }
                    fullWidthButton={ true }
                    onFormSubmit={ onSignup }
                    loading={ thinking }
                    error={ error }
                />
            </div>
            <div className={ styles.accountSignin }>
                Already have an account?
                <a selectid="signin" className={ styles.subtitleLink } target="_top" href="/account/signin">Sign in</a>
            </div>
            <div className={ styles.terminalSignin }>
                Bloomberg Anywhere Client?
                <a className={ styles.subtitleLink } target="_top" href="/account/signin">Sign in</a>
            </div>
        </div>
    );
};

export default Signup;
